export const hasRole = (person, roleID) =>
  person && person.roles && person.roles.find(role => Number(role.id) === roleID)

export const hasInterestedRole = (person, roleID) =>
  person &&
  person.interestedRoles &&
  person.interestedRoles.find(role => Number(role.id) === roleID)
